import React from 'react';
import PropTypes from 'prop-types';
import SMFormatHelper from 'components/helpers/SMFormatHelper';
import SMAppHelper from 'components/helpers/SMAppHelper';

class SMDashboardUserBaloonView extends React.Component {

  constructor(props) {
    super(props);
    
  }

  render() {
    const userImageUrl = SMFormatHelper.userImageUrl(this.props.user, this.props.image),
          imageTag = <img
      data-baloon-type={this.props.baloonType}
      data-baloon-data={this.props.baloonData}
      data-baloon-button-title={this.props.baloonButtonTitle}
      data-baloon-button-link={this.props.baloonButtonLink}
      src={userImageUrl}
      className={this.props.className}
      alt={this.props.name} />;
    if (SMAppHelper.userIsDeleted(this.props.user) || SMAppHelper.ownerIsDeleted(this.props.owner)) {
      return imageTag;
    } else {
      return(
        <a href={this.props.link} target={this.props.target}>
          {imageTag}
        </a>
      );
    }
  }
}

SMDashboardUserBaloonView.defaultProps = {
  target: ''
};

SMDashboardUserBaloonView.propTypes = {
  user: PropTypes.object.isRequired,
  link: PropTypes.string,
  target: PropTypes.string,
  baloonType: PropTypes.string,
  baloonData: PropTypes.string,
  baloonButtonTitle: PropTypes.string,
  baloonButtonLink: PropTypes.string,
  image: PropTypes.string,
  className: PropTypes.string,
  name: PropTypes.string
};
export default SMDashboardUserBaloonView;


// WEBPACK FOOTER //
// ./app/javascript/components/dashboard/shared/SMDashboardUserBaloonView.jsx